/**
* @file 战队-创建战队
* @author 余凯
*/

import React from 'react'
import { Steps, Select, Divider, Button, Row, Col, Form, Input, Result, Cascader } from 'antd';
import './index.less'
import { connect } from 'react-redux'
import Actions from '@/apis/team'
import cityDate from '@/utils/cities'

cityDate.map(v => ({}))

const { Option } = Select;

const { TextArea } = Input;

const { Step } = Steps;

const formItemLayout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 6 },
};
const formTailLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 8, offset: 9 },
};

@Form.create()
@connect(
  state => state.teamReducer,

)
class CreatTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      cityList: []
    }
  }

  async componentDidMount() {
    const res = await Actions.checkApply({ game_id: this.props.game })
    if (res.code == 200) {
      this.setState({
        current: res.data.apply === true ? 0 : 1
      })
      if (res.data.apply === true) {
        this.getCity()
      }
    }
  }

  getCity =async () => {
    const res = await Actions.getCity()
    if (res.code == 200) {
      this.setState({
        cityList: res.data
      })
    }
  }

  handleSubmit =  e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        values.city_id = values.city_id[1]
        await Actions.createTeam(values)
        const res = await Actions.checkApply({ game_id: this.props.game })
        if (res.code == 200) {
          this.setState({
            current: res.data.apply === true ? 0 : 1
          })
        }
      }
    });
  };

  render() {
    const { current, cityList } = this.state
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="creat_team" id="creat_team">
        <Steps className="steps" size="small" current={current}>
          <Step title="提交申请" />
          <Step title="管理员审核" />
          <Step title="创建成功" />
        </Steps>
        {current === 0 ? (
          <>
            <Form {...formItemLayout} onSubmit={this.handleSubmit} className="login-form">
              <Form.Item label="所属地区">
                {getFieldDecorator('city_id', {
                  rules: [{ required: true, message: '请选择所属地区!' }],
                })(
                  <Cascader
                    options={cityList}
                    onChange={this.onChangeCity}
                    placeholder="请选择所属地区"
                  />
                )}
              </Form.Item>
              <Form.Item label="所属游戏">
                {getFieldDecorator('game_id', {
                  initialValue: this.props.game,
                  rules: [{ required: true, message: '请选择所属游戏!' }],
                })(
                  <Select >
                    {this.props.gameList.map(
                      v => <Option key={v.game_id} value={v.game_id}>{v.game_name}</Option>)}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="战队名称">
                {getFieldDecorator('gameteam_name', {
                  rules: [{ required: true, message: '请输入战队名称!' }],
                })(
                  <Input
                    placeholder="战队名称小于8个中文字"
                    maxLength={7}
                  />,
                )}
              </Form.Item>
              <Form.Item label="战队介绍">
                {getFieldDecorator('intro', {
                  rules: [{ required: true, message: '请输入战队介绍!' }],
                })(
                  <TextArea allowClear placeholder="简介少于25个中文字" maxLength={25} />
                )}
              </Form.Item>
              <Form.Item label="QQ群">
                {getFieldDecorator('qq_group_id', {
                  // initialValue: '',
                  // rules: [{required: true, message: '请输入QQ群!'}],
                })(
                  <Input
                    placeholder="请正确填写，方便联系"
                  />,
                )}
              </Form.Item>
              <Form.Item label="联系QQ">
                {getFieldDecorator('contact_qq', {
                  // initialValue: '',
                  // rules: [{required: true, message: '请输入联系QQ!'}],
                })(
                  <Input
                    placeholder="请正确填写，方便联系"
                  />,
                )}
              </Form.Item>
              <Form.Item label="联系电话">
                {getFieldDecorator('contact_tel', {
                  rules: [{ required: true, message: '请输入联系电话!' }],
                })(
                  <Input
                    maxLength={11}
                    placeholder="请正确填写，方便联系"
                  />,
                )}
              </Form.Item>

              <Form.Item {...formTailLayout}>
                <Button type="primary" htmlType="submit" className="login-form-button">
                  创建
                </Button>
              </Form.Item>
            </Form>
            <Divider />
            <Row>
              <Col offset={7}>
                <ul>
                  <li>
                1. 创建战队队长游戏局数
                    {'>'}
1局
                  </li>
                  <li>
                    2. 创建战队系统将自动扣除1张“战队卡”（战队卡可在游戏商城购买）
                  </li>
                  <li>
                    3. 战队名称不允许出现政治，色情，恐怖等敏感文字
                  </li>
                  <li>
                    4. 提交完成后，7个工作日内审核创建完毕，查询进度可咨询客服
                  </li>
                </ul>
              </Col>
            </Row>
          </>
        ) : ''}
        {current === 1 ? (
          <Result
            title="提交完成后，7个工作日内审核创建完毕"
            subTitle="查询进度可咨询客服"
          />
        ) : ''}
      </div>
    );
  }
}

export default CreatTeam;
